export const EXECUTION_STAGES = [
  { value: "QUOTATION", label: "Cotação" },
  { value: "TRANSMISSION", label: "Transmissão da Proposta" },
];

export function getExecutionStageLabel(stageCode) {
  const stage = EXECUTION_STAGES.find((s) => s.value === stageCode);
  return stage ? stage.label : "Desconhecido";
}

export const PRICE_CHANGE_THRESHOLD = 0.01;
